import React, { useState } from 'react';

const inputClass = "w-full border border-gray-300 dark:border-white/15 p-3 rounded-lg bg-white dark:bg-white/5 text-gray-900 dark:text-white placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-gray-900 dark:focus:ring-white focus:border-gray-900 dark:focus:border-white transition-colors";

const TestimonialForm = ({ onClose }) => {
  const [name, setName] = useState('');
  const [text, setText] = useState('');
  const [gender, setGender] = useState('male');
  const [image, setImage] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [progress, setProgress] = useState(0);

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('names', name);
    formData.append('description', text);
    formData.append('gender', gender);

    const currentDate = new Date();
    const formattedDateTime = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')} ${String(currentDate.getHours()).padStart(2, '0')}:${String(currentDate.getMinutes()).padStart(2, '0')}:${String(currentDate.getSeconds()).padStart(2, '0')}`;
    formData.append('date', formattedDateTime);

    if (image) {
      formData.append('image', image);
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/api/testimonials/upload`, {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        setSuccessMessage('Your testimonial has been successfully uploaded! Please wait for review and approval from Elayone Music');
        setProgress(100);
        setName('');
        setText('');
        setGender('male');
        setImage(null);
        setTimeout(() => {
          setSuccessMessage('');
          setProgress(0);
          onClose();
        }, 10000);
      } else {
        throw new Error('Failed to upload testimonial');
      }
    } catch (error) {
      setErrorMessage(error.message);
      setProgress(100);
      setTimeout(() => {
        setErrorMessage('');
        setProgress(0);
      }, 5000);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/70 z-50 p-4" onClick={onClose}>
      <div
        className="bg-white dark:bg-[#111010] border border-gray-200 dark:border-white/10 text-gray-900 dark:text-white
          p-8 rounded-2xl max-w-md w-full shadow-2xl relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-900 dark:hover:text-white transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"><path d="M6 18L18 6M6 6l12 12" /></svg>
        </button>

        <h2 className="text-2xl text-center mb-6 font-glsnecb tracking-wide uppercase">Share Your Testimony</h2>
        <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
          <input
            type="text"
            placeholder="Your Name (optional)"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className={inputClass}
          />
          <textarea
            placeholder="Your Testimonial"
            value={text}
            onChange={(e) => setText(e.target.value)}
            required
            rows="4"
            className={`${inputClass} resize-none`}
          />
          <div className="flex gap-6">
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
              <input
                type="radio"
                value="male"
                checked={gender === 'male'}
                onChange={(e) => setGender(e.target.value)}
              />
              Male
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 dark:text-gray-300">
              <input
                type="radio"
                value="female"
                checked={gender === 'female'}
                onChange={(e) => setGender(e.target.value)}
              />
              Female
            </label>
          </div>
          <div className="flex items-center gap-3">
            <label className="bg-gray-100 dark:bg-white/10 py-2 px-4 rounded-lg cursor-pointer hover:bg-gray-200 dark:hover:bg-white/15 transition-colors">
              <span className="text-gray-700 dark:text-gray-200 text-sm">Choose Photo</span>
              <input type="file" accept="image/*" onChange={handleImageChange} className="hidden" />
            </label>
            {image && <span className="text-gray-500 dark:text-gray-400 text-sm truncate">{image.name}</span>}
          </div>

          <button
            type="submit"
            className="w-full bg-gray-900 dark:bg-white text-white dark:text-black text-sm font-medium py-3 px-4 rounded-lg hover:bg-black dark:hover:bg-gray-200 transition-colors"
          >
            Submit
          </button>
        </form>

        {successMessage && (
          <div className="fixed top-6 left-4 right-4 sm:mx-auto sm:w-80 bg-green-100 text-green-900 border-green-500 pt-2 rounded-t-md shadow-md z-50">
            <div className="flex justify-center items-center">
              <span className="text-center p-1">{successMessage}</span>
            </div>
            <div className="h-1 mt-1 bg-green-300">
              <div style={{ width: `${progress}%` }} className="h-full bg-green-700 transition-all duration-500" />
            </div>
          </div>
        )}

        {errorMessage && (
          <div className="fixed top-6 left-4 right-4 sm:mx-auto sm:w-80 bg-red-100 text-red-900 border-red-500 pt-2 rounded-t-md shadow-md z-50">
            <div className="flex justify-center items-center">
              <span className="text-center p-1">Failed to upload testimonial!</span>
            </div>
            <div className="h-1 mt-1 bg-red-300">
              <div style={{ width: `${progress}%` }} className="h-full bg-red-700 transition-all duration-500" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TestimonialForm;
